export const instanceName = 'AppSearchInLoanAdd'
